/* global customSelect */

import "./polyfill";
// import stickybits from 'stickybits';
//
// import MobileMenu from './components/MobileMenu';
import MainNavigation from './components/MainNavigation';
import ToggleableComponent from './components/ToggleableComponent';
import HeaderSearch from "./components/HeaderSearch";
import MobileMenu from "./components/MobileMenu";

// import {
//   debounce,
//   toTop
// } from './library';
// import { SCROLL_DEBOUNCE } from "./constants";


(function (Drupal, $) {
  //Use this to interact with drupal behaviors module
  Drupal.behaviors.main = {
    attach: function (context, settings) {

      // TODO: refactor this for call jQuery only first time.
      if (context != document){
        return;
      }

      // -------------
      // Accordion Toggle
      const accordions = document.querySelectorAll('.accordion-item');

      accordions.forEach(accordionItem => {
        new ToggleableComponent(
          accordionItem.querySelector('.accordion-item__heading'),
          accordionItem
        );
      });

      const staff_radio_form = document.getElementById('tab--contact');
      if (staff_radio_form && window.location.hash === '#contact') {
        staff_radio_form.checked = true;
      }

      window.searchFormToggle = new HeaderSearch();
      window.mobileMenu = new MobileMenu();

      var customExposedForm = $(".views-exposed-form");
      if (customExposedForm.length > 0) {
        var gallerySelect = $(".views-exposed-form select.custom-select");

        if (gallerySelect.length) {
          gallerySelect.customSelect();

          // (e) => { console.log(`${e.target} has changed it's value 👌`)})

          gallerySelect.customSelect('select')
            .on('change', (e) => {
              // console.log(`${e.target} has changed it's value 👌`)
              customExposedForm.submit();
            });
        }
      }

    }//end of inherited context and settings from drupal
  }//end of drupal behaviors
  /* global Javascript */

  new MainNavigation();

}(Drupal, jQuery)); //end of drupal and jQuery closure

